import { isAxiosError } from 'axios'

export interface ApiErrorDetail {
  field: string
  messages: string[]
}

export interface ApiError {
  statusCode?: number
  error?: string
  message?: string
  code?: string
  details?: ApiErrorDetail[]
  path?: string
  timestamp?: string
}

const LOGOUT_ERROR_CODES = new Set([
  'AUTH_INVALID_TOKEN',
  'AUTH_ACCESS_DENIED',
  'AUTH_REFRESH_TOKEN_MALFORMED',
  'AUTH_TOKEN_REUSE',
  'AUTH_USER_INACTIVE',
])

export const AUTH_USER_INACTIVE_CODE = 'AUTH_USER_INACTIVE'

export class UserInactiveError extends Error {
  code = AUTH_USER_INACTIVE_CODE

  constructor(message = 'Sua conta está desativada. Entre em contato com o administrador.') {
    super(message)
    this.name = 'UserInactiveError'
  }
}

export function shouldLogoutForCode(code?: string | null): boolean {
  if (!code) return false

  return LOGOUT_ERROR_CODES.has(code)
}

export function parseApiError(error: unknown): ApiError | null {
  if (isAxiosError(error) && error.response?.data) {
    return error.response.data as ApiError
  }

  if (error instanceof Error) {
    try {
      return JSON.parse(error.message) as ApiError
    } catch {
      return null
    }
  }

  return null
}

export function normalizeApiErrorDetails(
  details?: ApiErrorDetail[],
): Array<{ field: string; message: string }> {
  if (!details || details.length === 0) return []

  return details.flatMap((detail) => {
    const field = detail.field?.trim()
    const messages = Array.isArray(detail.messages) ? detail.messages : []
    const message = messages
      .map((entry) => entry.trim())
      .filter(Boolean)
      .join(' ')

    if (!field || !message) return []

    return [{ field, message }]
  })
}
